import React, {useEffect, useState} from "react";
import "./style.css";

export const Percentage = ({
                                 start,
    successBack
                             }) => {
    const [progress, setProgress] = React.useState(0);
    const hasCalledSuccessRef = React.useRef(false);

    useEffect(() => {
        if (!start) {
            setProgress(0);
            hasCalledSuccessRef.current = false;
            return ;
        }

        // 5s，progress 0-100,先快后慢,每次+7
        const interval = setInterval(() => {
            if (!start) {
                clearInterval(interval);
                return ;
            }
            setProgress((prev) => {
                if (prev >= 100) {
                    clearInterval(interval);
                    // 延迟到下一个事件循环调用，避免在渲染期间更新父组件
                    if (!hasCalledSuccessRef.current) {
                        hasCalledSuccessRef.current = true;
                        setTimeout(() => {
                            successBack();
                        }, 0);
                    }
                    return 100;
                }


                if (prev > 70 && Math.random() < 0.7) {
                    return prev;

                }

                return Math.min(prev + 7, 100);
            });
        }, 100);

        return () => clearInterval(interval);

    }, [start, successBack]);

    return (
        <div className={`percentage-wrap ${start && "percentage-wrap-start"}`}>
            <div className="percentage-group" style={{width: `${progress}%`}}>
                <div className="percentage-group-profile">{progress}%</div>
            </div>
        </div>
    );
};
